module.exports = __webpack_public_path__ + "static/img/b5_footer.6c30f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b5_footer.png
// module id = D49C
// module chunks = 1